module.exports = __webpack_public_path__ + "img/venus8.aaef5297.png";